/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Risk-Model-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 2019-06-07
 * Copyright All Rights Reserved
 */

export const CREATE_PASSWORD_FORM = 'createPassword';
export const INVENTORY_PAGE_CONTROL_FORM = 'inventoryPageControl';
export const RESET_PASSWORD_FORM = 'resetPassword';
export const SIGN_IN_FORM = 'signIn';



// WEBPACK FOOTER //
// ./js/constants/forms.js